import React from 'react';
export function Science() {
  return <section className="bg-cream py-16 md:py-24" id="science-section" data-id="element-204">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <div className="flex flex-col items-center text-center" data-id="element-206">
          <span className="inline-block bg-sage/20 text-sage font-bold text-xs px-3 py-1 rounded-full uppercase tracking-wider mb-6" data-id="element-207">
            Neurobiología Aplicada
          </span>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-charcoal mb-8 leading-tight" data-id="element-208">
            No es timidez. Es un cortocircuito en tu Nervio Vago.
          </h2>

          <div className="space-y-6 text-charcoal/80 text-lg md:text-xl leading-relaxed mb-12 max-w-3xl text-left" data-id="element-209">
            <p data-id="element-210">
              Imagina que tu cuerpo tiene una alarma de incendios. El{' '}
              <strong data-id="element-211">Nervio Vago</strong> es el cable que conecta esa alarma
              con tu cerebro.
            </p>

            <div className="relative w-full max-w-lg mx-auto my-10 rounded-3xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-212">
              <img src="https://cdn.magicpatterns.com/uploads/aK2RRauyPYD7QtuaiqjyuB/download.jpg" alt="Cerebro ansioso vs Cerebro en calma" className="w-full h-auto object-cover" data-id="element-213" />
            </div>

            <p data-id="element-214">
              En las personas con ansiedad social, esta alarma está rota. Suena
              a todo volumen cuando vas a una reunión o intentas hablar con
              alguien, haciéndote sentir que estás en peligro de muerte, aunque
              lógicamente sepas que estás a salvo.
            </p>
            <p data-id="element-215">
              Por eso intentar "calmarte" pensando positivo no funciona. Tu
              cuerpo está en modo supervivencia. El Protocolo usa ejercicios
              físicos simples para "apagar" esa alarma directamente desde el
              nervio, devolviéndote la calma en menos de dos minutos.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 w-full" data-id="element-216">
            <div className="bg-white p-8 rounded-2xl border-2 border-terracotta/20 shadow-md text-center transform hover:-translate-y-1 transition-transform" data-id="element-217">
              <p className="text-5xl font-heading font-bold text-terracotta mb-3" data-id="element-218">
                85%
              </p>
              <p className="text-base text-charcoal/70 font-medium" data-id="element-219">
                Nunca reciben ayuda adecuada
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl border-2 border-sage/20 shadow-md text-center transform hover:-translate-y-1 transition-transform" data-id="element-220">
              <p className="text-5xl font-heading font-bold text-sage mb-3" data-id="element-221">
                80%
              </p>
              <p className="text-base text-charcoal/70 font-medium" data-id="element-222">
                Del estrés lo controla este nervio
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl border-2 border-yellow/40 shadow-md text-center transform hover:-translate-y-1 transition-transform" data-id="element-223">
              <p className="text-5xl font-heading font-bold text-yellow mb-3" data-id="element-224">
                120<span className="text-3xl" data-id="element-225"> seg</span>
              </p>
              <p className="text-base text-charcoal/70 font-medium" data-id="element-226">
                Para resetear tu sistema
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}